import OpenNewWin from '../win';
import { FILE_VIEW_URL } from '@/config';

export const imageDownload = (imgsrc, name) => {
  //下载图片地址和图片名
  const image = new Image();
  // 解决跨域 Canvas 污染问题
  image.setAttribute('crossOrigin', 'anonymous');
  image.onload = () => {
    try {
      const canvas = document.createElement('canvas');
      canvas.width = image.width;
      canvas.height = image.height;
      const context = canvas.getContext('2d');
      context.drawImage(image, 0, 0, image.width, image.height);
      const url = canvas.toDataURL('image/png'); //得到图片的base64编码数据
      const a = document.createElement('a'); // 生成一个a元素
      const event = new MouseEvent('click'); // 创建一个单击事件
      a.download = name || 'invoice'; // 设置图片名称
      a.href = url; // 将生成的URL设置为a.href属性
      a.dispatchEvent(event); // 触发a的单击事件
    } catch (e) {
      console.info('生成下载出错', e);
    }
  };
  image.src = imgsrc;
};

export const previewBill = (url: string) => {
  const win = new OpenNewWin();
  win.createWin();
  win.setUrl(`${FILE_VIEW_URL}?url=${url}`);
};

/**
 * Descripttion：可以预览任意的地址
 */
export const previewBillBrbitrarily = (url: string) => {
  const win = new OpenNewWin();
  win.createWin();
  win.setUrl(url);
};
